import {Component , Inject , OnInit , ViewEncapsulation} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {OrganizationsService} from '../../../../../core/services/organizations.service';
import {FrontUserService} from '../../../../../core/services/frontUsers.service';
import {EventTypeService} from '../../../../../core/services/eventType.service';
import {ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import {forkJoin, of} from 'rxjs';
import {tap} from 'rxjs/operators';


@Component({
    selector: 'wizzard-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class WizzardDialogComponent implements OnInit {
  users = [];
  targetGroups = [];
  eventType = [];
  all = false;
  migrationInProcess = false;
  migrationProgress = 0;
  migrationSuccess = false;
  migrationFailed = false;
  countdown  = 5;
  constructor (private organizationService: OrganizationsService , private frontUser: FrontUserService ,
               public dialog: MatDialog , private eventService: EventTypeService ,
               public toastr: ToastrService , private spinner: NgxSpinnerService,
  public dialogRef: MatDialogRef<WizzardDialogComponent> ,
               @Inject(MAT_DIALOG_DATA) private data: any) {
    this.init();
  }

  init() {
    this.spinner.show();
    this.organizationService.getWizzardData(this.data.id).subscribe((res: any) => {
      for (let i = 0; i < res.length; i++) {
        if (res[ i ].canTrasfer > 0) {
          res[ i ].transfer = [];
          res[ i ].transfer.push({id: null , name: 'Transfer' , credit: res[ i ].canTrasfer});
        }
      }
      this.users = res;
    });
    this.frontUser.getTargetGroup().subscribe((res: any) => {
      this.targetGroups = res.targetGroups;
      this.spinner.hide();
    });

    this.eventService.getEventTypeDropDown().subscribe((res: any) => {
      this.eventType = res;
    });
  }

  ngOnInit () {

  }

  openTgDialog (item , index) {
    const dialogRef = this.dialog.open(TGDialog , {
      width: '300px' ,
      data: {
        targetGroups: this.targetGroups ,
        selected: item ? item.id : null
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      for (let i = 0; i < this.targetGroups.length; i++) {
        if (this.targetGroups[ i ].id === result) {
          this.users[ index ].nextTG = this.targetGroups[ i ];
          break;
        }
      }
      console.log(result);
    });
  }

  openTransferDialog (tranfer , index) {
    const dialogRef = this.dialog.open(TransferDialog , {
      width: '450px' ,
      data: {
        eventType: this.eventType ,
        tranfer: tranfer
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  selectAll () {
    console.log(this.all);
    for (let i = 0; i < this.users.length; i++) {
      this.users[ i ].selected = this.all;
    }
  }

  checkAll () {
    let count = 0;
    for (let i = 0; i < this.users.length; i++) {
      if (this.users[ i ].selected) {
        count++;
      }
    }
    if (this.users.length === count) {
      this.all = true;
    } else {
      this.all = false;
    }
  }

  migrateUser() {
    this.migrationInProcess = true;
    let requests = [];
    for (let i = 0; i < this.users.length; i++) {
      if (this.users[i].selected && !!this.users[i].nextTG) {
        let request = this.frontUser.migrateUser(this.users[i]).pipe(tap(() => console.log(`Request ${i + 1} finished`)));
        requests.push(request);
      }
    }
    let completedRequests = 0;
    const totalRequests = requests.length;

    const requestsWithProgress = requests.map(req$ =>
      req$.pipe(
        tap(() => {
          completedRequests++;
          this.migrationProgress = (completedRequests / totalRequests) * 100;
        })
      )
    );

    forkJoin(requestsWithProgress).subscribe({
      next: (results) => {
        this.migrationSuccess = true;
        this.updateProcess();
      },
      error: (error) => {
        this.migrationFailed = true;
        this.updateProcess();
      }
    });
  }

  updateProcess() {
    this.countdown = 5;
    const timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(timer);
        this.migrationInProcess = false;
        this.all = false;
        this.init();
      }
    }, 1000);
  }
}

@Component({
    selector: 'tg-example-dialog',
    templateUrl: 'tg-dialog.html',
    styles: `
    .tg-example-modal{
      padding: 20px;
    }
    `,
    standalone: false
})
export class TGDialog {
  constructor (public dialogRef: MatDialogRef<TGDialog> ,
               @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
  }

  onNoClick (): void {
    this.dialogRef.close();
  }

}

@Component({
    selector: 'transfer-example-dialog',
    templateUrl: 'transfer-dialog.html',
    standalone: false
})
export class TransferDialog {
  selected;
  credit = 1;
  transferData;
  eventTypes = [];

  constructor (public dialogRef: MatDialogRef<TGDialog> ,
               @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.transferData = data.tranfer;
    this.eventTypes = data.eventType;
  }

  onNoClick (): void {
    this.dialogRef.close();
  }

  addNew (item , credit) {
    if (item && credit > 0 && (this.transferData[ 0 ].credit - credit) >= 0) {
      for (let i = 0; i < this.eventTypes.length; i++) {
        if (this.eventTypes[ i ].id === item) {
          this.transferData.push({name: this.eventTypes[ i ].name , id: this.eventTypes[ i ].id , credit: credit});
          this.transferData[ 0 ].credit = this.transferData[ 0 ].credit - credit;
        }
      }
    }
  }

  removeFromTranfer (index) {
    this.transferData[ 0 ].credit = this.transferData[ 0 ].credit + this.transferData[ index ].credit;
    this.transferData.splice(index , 1);
  }

}
